export default {"src":"/_next/static/media/payment-amex.03501ba2.svg","height":30,"width":44,"blurWidth":0,"blurHeight":0};